module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/954e7a4e804e25fa93747c0f4f46f5ba.png";